export const config = {
  timing: 'ms'
};
export const configureMotion = function configureMotion(configuration) {
  Object.assign(config, configuration);
};
//# sourceMappingURL=configureMotion.js.map